export type CreditActionType =
  | 'send_alliance_request'
  | 'accept_quote_request'
  | 'accept_quote_alliance_request'
  | 'submit_public_job_quote'
  | 'publish_job_standard'
  | 'publish_job_featured'
  | 'publish_job_urgent';

export type CreditTransactionActionType =
  | 'purchase'
  | 'refund'
  | 'admin_adjustment'
  | 'signup_gift'
  | 'monthly_gift'
  | CreditActionType;

export interface AdminCreditTransaction {
  id: number;
  created_at: string;
  action_type: CreditTransactionActionType;
  amount: number;
  balance_before: number;
  balance_after: number;
  reference_id: string | null;
  metadata: Record<string, unknown> | null;
  user_id: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  role: string | null;
  reason: string;
}

export interface CreditWallet {
  user_id: string;
  balance: number;
  obnl_free_balance?: number;
  created_at: string;
  updated_at: string;
}

export interface CreditPackage {
  stripe_product_id: string;
  stripe_price_id: string;
  credits: number;
  price_cents: number;
  name?: string;
  description?: string;
  is_active: boolean;
  is_default_price: boolean;
  last_synced_at?: string;
  created_at: string;
  updated_at: string;
}

export interface CreditActionCost {
  action_type: CreditActionType;
  cost: number;
  description?: string;
  is_active: boolean;
}

export interface CreditLogItem {
  id: number;
  created_at: string;
  title: string;
  action_type: CreditActionType;
  credits: number;
}

export type CreditGiftMode = 'signup' | 'monthly' | null;

export interface CreditGiftConfig {
  id: number;
  mode: CreditGiftMode;
  signup_credits_freelancer: number;
  signup_credits_recruiter: number;
  monthly_credits_freelancer: number;
  monthly_credits_recruiter: number;
  monthly_credits_obnl: number;
  monthly_cumulative: boolean;
  updated_at: string;
}

// Helper to format price from cents to dollars
export const formatPrice = (cents: number): string => {
  return `$${(cents / 100).toFixed(2)}`;
};

// Helper to calculate savings percentage
export const calculateSavings = (credits: number, priceCents: number): number => {
  const basePrice = credits * 10; // Base: 1 credit = $0.10
  const actualPrice = priceCents;
  const savings = ((basePrice - actualPrice) / basePrice) * 100;
  return Math.round(savings);
};
